/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setModuleSelected,
  setProcesSelected,
} from "../../libs/redux/slices/MenuSlice/menuSlice";
import {
  setRedirectGraph,
  unsetRedirectGraph,
  getWithRedirect,
  getRedirectMODIDXXX,
  getRedirectPROIDXXX,
} from "../../libs/redux/slices/Graficsx/graficsxSlice";
import { getMenuUser } from "../../libs/redux/slices/authSlice/authSlice";

export function useRedirectGraph({ MODIDXXX, PROIDXXX }) {
  const dispatch = useDispatch();

  const isWithRedirect = useSelector(getWithRedirect);
  const redirectMODIDXXX = useSelector(getRedirectMODIDXXX);
  const redirectPROIDXXX = useSelector(getRedirectPROIDXXX);

  const menuData = useSelector(getMenuUser);

  const timerRef = useRef(null);

  const handleNewWindow = () => {
    const url = process.env.REACT_APP_CIMA_WEB;
    return window.open(`${url}`, "_blank");
  };

  const handleRedirectWithRouter = () => {
    dispatch(setRedirectGraph({ MODIDXXX, PROIDXXX }));
    handleNewWindow();

    timerRef.current = setTimeout(() => {
      dispatch(unsetRedirectGraph());
    }, 5000);
  };

  const unsetRedirectPersist = () => {
    dispatch(unsetRedirectGraph());
  };

  const getModuleItemAndProcessItem = () => {
    let menuItems = {};
    menuData.forEach((menu) => {
      if (String(menu.MODIDXXX) === String(MODIDXXX)) {
        menu.CIMS0004.forEach((submenu) => {
          if (String(submenu.PROIDXXX) === String(PROIDXXX)) {
            menuItems = {
              moduleItem: menu,
              processItem: submenu,
            };
          }
        });
      }
    });
    return menuItems;
  };

  const handleRouterComponents = () => {
    const { moduleItem, processItem } = getModuleItemAndProcessItem();
    if (!moduleItem || !processItem) return;
    dispatch(setModuleSelected(moduleItem));
    dispatch(setProcesSelected(processItem));
  };

  useEffect(() => {
    if (!window.opener) return;

    if (!isWithRedirect) return;
    if (!menuData?.length) return;
    if (
      String(redirectMODIDXXX) !== String(MODIDXXX) ||
      String(redirectPROIDXXX) !== String(PROIDXXX)
    ) {
      return;
    }

    handleRouterComponents();
    dispatch(unsetRedirectGraph());
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isWithRedirect, menuData, redirectMODIDXXX, redirectPROIDXXX, MODIDXXX, PROIDXXX]);

  return {
    handleRedirectWithRouter,
    unsetRedirectPersist,
  };
}
